var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"c-list--checkup"},[_c('li',{staticClass:"c-list--checkup__item"},[_c('span',{staticClass:"c-list--checkup__label judgement"},[_vm._v("判定")]),_c('div',{staticClass:"c-list--checkup__content"},[(!_vm.hasError)?_c('p',[_vm._v("\n        HTTP2の対応ができています。\n      ")]):_c('p',[_vm._v("\n        HTTP2の対応ができていません。\n      ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }